import { EventView, TaskView } from '@ndvr/customer-api';

import { eventGuidComponent, householdGuidComponent, taskGuidComponent } from '@/views/ai-chat/prompt-components';

export const createPrepPrompt = (event: EventView): string =>
    `Produce a **pre-meeting brief** for ${householdGuidComponent(event.clientHouseholdGUID)}'s upcoming meeting **"${event.title}"** ${eventGuidComponent(event.eventGUID)}.

Include:
- Open tasks and outstanding items
- Relevant portfolio updates or alerts
- Key themes from recent notes and correspondence
- 3–5 suggested talking points`;

export const createFollowupPrompt = (event: EventView): string =>
    `Produce a **post-meeting summary** for **"${event.title}"** ${eventGuidComponent(event.eventGUID)} with ${householdGuidComponent(event.clientHouseholdGUID)}.

Include:
- Draft follow-up email to the client
- Key topics discussed
- Decisions or commitments made
- Prioritized action items with suggested owners

Flag any items that should become tasks or calendar events.`;

export const createTaskPrompt = (task: TaskView): string =>
    `Help me **brainstorm and plan** for the task **"${task.title}"** ${taskGuidComponent(task.taskGUID)}${task.householdGUID ? ` for ${householdGuidComponent(task.householdGUID)}` : ''}.

Review related context and suggest:
- Approaches or strategies
- Concrete next steps
- Any potential blockers or considerations`;
